import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo_Inline_Circle({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // SVG circular progress component
  const CircularProgress = ({ percentage }) => {
    const radius = 50;
    const strokeWidth = 7;
    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <div className="position-relative d-flex justify-content-center align-items-center ">
        <svg height={radius * 2} width={radius * 2} style={{ transform: "rotate(-90deg)" }}>
          {/* Background circle */}
          <circle
            stroke="#F5F5F5"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Progress circle */}
          <circle
            stroke="#23C5D3"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            style={{ strokeDashoffset }}
            //strokeLinecap="round"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        {/* Percentage text in center */}
        <div className="position-absolute d-flex flex-column justify-content-center align-items-center">
          <div
            className={"fw-semibold"}
            style={{ fontSize: "7px", color: "#999", marginTop: "4px", textAlign: "center" }}
          >
            Completed
          </div>
          <div style={{ fontSize: "14px", fontWeight: "bold", color: "#303030" }}>{percentage}%</div>
        </div>
      </div>
    );
  };

  return (
    <Row className={"mx-0"} style={{ height: Number(item.height) }}>
      <div>
        {/* Main horizontal layout */}
        <Row className="align-items-center">
          {/* Title - Left */}
          <Col xs={3}>
            <div style={{ fontSize: "16px", fontWeight: "600", color: "#092441" }}>{item.name}</div>
          </Col>

          {/* Circular progress with label - Center-Left */}
          <Col xs="auto" className="pe-4">
            <div className="d-flex flex-column align-items-center">
              <CircularProgress percentage={elementScore} />
            </div>
          </Col>

          {/* General information text - Right */}
          <Col>
            {item.generalInformationText?.length > 2 && (
              <div
                style={{ fontSize: "11px", color: "#666", lineHeight: "1.1", textAlign: "justify" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              />
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
